import { Navigate, useLocation } from "react-router-dom";
import * as Config from "../../config/config";
import { useAuth } from "../../hooks/customers/AuthProvider";

const ProtectedRoute = ({ children }) => {

    const auth = useAuth();
    const customer = auth?.customer;

    const location = useLocation();
    const currentPath = location.pathname;

    const isRestricted = Config.RESTRICTED_MENUS_FOR_DM.some((path) => {
        const regexPattern = new RegExp(`^${path.replace(/:\w+/g, "\\d+")}$`);
        return regexPattern.test(path);
    });

    const hqMenuRestricted = Config.RESTRICTED_MENUS_FOR_BRANCH.some((path) => {
        const regexPattern = new RegExp(`^${path.replace(/:\w+/g, "\\d+")}$`, "i");
        return regexPattern.test(currentPath);
    });

    if (customer?.role === Config.DISTRICT_MANAGER_ROLE && isRestricted) {
        return <Navigate to="/unauthorized" />;
    }

    if (customer?.role === Config.BRANCH_CUSTOMER_ROLE && hqMenuRestricted) {
        return <Navigate to="/unauthorized" />;
    }

    return children;
};

export default ProtectedRoute;